import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  schema?: object;
}

export default function SEO({ title, description, keywords, canonicalUrl, ogImage, ogType = 'website', schema }: SEOProps) {
  const location = useLocation();
  const baseUrl = 'https://www.koreancomic.cn';
  const currentUrl = canonicalUrl || `${baseUrl}${location.pathname}`;

  const defaultTitle = '韩国漫画网-韩漫在线阅读-免费的韩国漫画-无删减韩漫大全';
  const defaultDescription = '韩国漫画网支持韩漫在线阅读，提供免费的韩国漫画和无删减韩漫大全，资源持续更新，让您尽情浏览各类韩漫内容。';
  const defaultKeywords = '韩国漫画网,韩漫在线阅读,免费韩国漫画,无删减韩漫大全';

  const finalTitle = title || defaultTitle;
  const finalDescription = description || defaultDescription;
  const finalKeywords = keywords || defaultKeywords;

  useEffect(() => {
    document.title = finalTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', finalDescription);
    setMeta('keywords', finalKeywords);

    setMeta('og:title', finalTitle, true);
    setMeta('og:description', finalDescription, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', currentUrl, true);
    setMeta('og:site_name', '韩国漫画网', true);
    if (ogImage) setMeta('og:image', ogImage, true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', finalTitle);
    setMeta('twitter:description', finalDescription);
    if (ogImage) setMeta('twitter:image', ogImage);

    let canonicalEl = document.querySelector('link[rel="canonical"]');
    if (!canonicalEl) {
      canonicalEl = document.createElement('link');
      canonicalEl.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.setAttribute('href', currentUrl);

    if (schema) {
      const existingScript = document.getElementById('schema-jsonld');
      if (existingScript) existingScript.remove();
      const script = document.createElement('script');
      script.id = 'schema-jsonld';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema, null, 2);
      document.head.appendChild(script);
    }
  }, [finalTitle, finalDescription, finalKeywords, currentUrl, ogImage, ogType, schema]);

  return null;
}